import React, { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import * as Sentry from "@sentry/react";
import { toast } from "react-toastify";

import { checkNavigationAccess, pagePathUtils } from "~/utils";

import { EmployeeProfileType, NavigationItemCompanyType } from "~/domains";

type PropsType = {
  currentEmployee: EmployeeProfileType;
  navigationItems: NavigationItemCompanyType[];
  children: ReactNode;
};

export const NavigationAccessGuard: FC<PropsType> = ({
  currentEmployee,
  navigationItems,
  children,
}: PropsType) => {
  const location = useLocation();

  const defaultBusinessSectionId =
    currentEmployee.businessSections[0]?.id || "";
  const currentPath = location.pathname;

  const hasNavigationAccess = checkNavigationAccess(
    currentPath,
    navigationItems,
    defaultBusinessSectionId,
  );

  if (!hasNavigationAccess) {
    const error = new Error("このページへのアクセス権限がありません");
    Sentry.captureException(error);
    toast.error(error.message);

    const redirectPath = pagePathUtils.isManagerPage()
      ? "/managers/profile"
      : "/profile";

    return (
      <Navigate to={redirectPath} replace state={{ error: error.message }} />
    );
  }

  return children;
};
